var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoconnectmgi2White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 676.147,
    height: 207.3,
    viewBox: "0 0 676.147 207.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M2.593,99.017a92.09,92.09,0,1,1,1.873,18.574A92.09,92.09,0,0,1,2.593,99.017Z",
    transform: "translate(-2.593 -7.02)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logoconnectmgi2white",
    transform: "translate(-1145.803 -188.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    transform: "translate(1146.95 -46.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_577",
    transform: "translate(233 236.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_474",
    transform: "translate(2.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    d: "M179.945-23.9H163.416l-.386,1.081-1.467,7.183-.386,1.081-.7,3.939v1.081l-.7,2.163L159.4-5.9h11.817a9.211,9.211,0,0,0,7.878-6.488h0l1.081-4.325v-.7l1.081-5.02.386-1.467Z",
    transform: "translate(-3.694 23.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    d: "M160.6,3.5h-4.634L140.9,74.943h5.02a13.414,13.414,0,0,0,12.59-10.427L171.408,3.5Z",
    transform: "translate(0.518 17.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    d: "M7.308,62.824l18.3-39.081L14.877,74.718H29.629L42.141,15.865a11.463,11.463,0,0,0-1.467-9.732,10.2,10.2,0,0,0-8.96-3.553,16.412,16.412,0,0,0-4.325.386,14.257,14.257,0,0,0-10.736,8.959L-2.038,50.312l-.309-38.386A8.716,8.716,0,0,0-9.529,2.889a16.953,16.953,0,0,0-3.939-.309A17.516,17.516,0,0,0-23.9,6.133a17.514,17.514,0,0,0-5.715,9.732L-42.2,74.718h14.752l10.736-50.975,1.467,38.077.386,5.02c0,1.081.386,2.549.386,3.553.7,3.553,3.939,6.488,7.569,6.1A10.852,10.852,0,0,0,2.75,71.087l.386-.386a34.39,34.39,0,0,0,2.549-3.939Z",
    transform: "translate(42.2 17.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    d: "M66.494,63a10.926,10.926,0,0,0,.386,3.553,7.5,7.5,0,0,0,3.939,5.715,19.4,19.4,0,0,0,10.736,2.549h17.61a17.857,17.857,0,0,0,16.142-8.65,23.87,23.87,0,0,0,3.244-9.654l4.634-22.63H105.961l-1.776,7.878h1.776L103.1,55.735v.386c-.7,2.163-2.549,3.244-5.715,3.244h-12.2c-1.467-.386-2.549-1.467-2.549-2.549V56.43L90.205,21.6a3.874,3.874,0,0,1,3.553-2.858H122.1L125.344,3.3H96.307A23.161,23.161,0,0,0,81.941,7.386a24.789,24.789,0,0,0-6.8,13.671S67.267,58.748,66.88,60.215A8.354,8.354,0,0,0,66.494,63Z",
    transform: "translate(17.461 17.715)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1451",
    d: "M-45,36.5",
    transform: "translate(45 10.15)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    width: 460.95,
    height: 125.7,
    transform: "translate(1360 255)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dashboardlogocompletw",
    transform: "translate(1027.95 -261.451)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "DASHBOARD",
    transform: "translate(346 630.451)",
    fontSize: 90,
    fontFamily: "Young"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CONNECT"))), /*#__PURE__*/React.createElement("g", {
    id: "Logo-BG-Approve",
    transform: "translate(1143.21 183.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(2.593 6.912)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 92.194,
    cy: 92.194,
    r: 92.194,
    transform: "translate(0 0)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0 0.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 200.791,
    height: 129.806,
    transform: "translate(-11.699 -31.375)",
    fill: "#0094cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(36.627 22.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M75.514,12.616A55.726,55.726,0,0,1,103.264,25.5c-2.373,2.162-4.67,4.407-6.89,6.676a46.372,46.372,0,1,0,15.872,26.605,81.314,81.314,0,0,1,8.6-5.157A55.991,55.991,0,1,1,75.509,12.616",
    transform: "translate(-10.713 -11.917)",
    fill: "#004b93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M16.057,51.751A55.8,55.8,0,0,1,38.363,42.2c5.251,8.279,9.559,19.494,10.353,26.943C66.622,46,88.979,17.314,110.063,13.082A94.264,94.264,0,0,0,103.915,43.5C81.277,50.145,59.692,75.963,44.8,93.193,39.544,79.235,29.952,58.6,16.057,51.751",
    transform: "translate(8.06 -7.817)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "AP",
    transform: "translate(38.813 157.162)",
    fill: "#fff",
    fontSize: 70,
    fontFamily: "Young",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.05em"
  }, "P")))), /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(1146 188.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20",
    "data-name": "Groupe 20"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 93,
    cy: 93,
    r: 93,
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(29.153 18.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_1",
    "data-name": "Ligne 1",
    d: "M3.2,59.7H-.4V0H3.2Z",
    transform: "translate(62.999 78.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M57.613,51.4h-26a6.6,6.6,0,0,1-6.6-6.6V21.246h3.6V44.809a3,3,0,0,0,3,3h26Z",
    transform: "translate(59.99 57.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M34.847,51.4h-26V47.8h26a3,3,0,0,0,3-3V21.246h3.6V44.809A6.6,6.6,0,0,1,34.847,51.4Z",
    transform: "translate(2.361 57.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M109.989,82.471A25.2,25.2,0,1,0,101.136,33.7a34.957,34.957,0,0,0-69.488,4.17,22.764,22.764,0,0,0-2.861-.2,22.4,22.4,0,1,0,0,44.8h81.2Z",
    transform: "translate(-6.388 -4.066)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 13.093,
    cy: 13.093,
    r: 13.093,
    transform: "translate(27.264 112.222)",
    fill: "#fbba00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 13.093,
    cy: 13.093,
    r: 13.093,
    transform: "translate(80.463 143.566)",
    fill: "#98c226"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 13.093,
    cy: 13.093,
    r: 13.093,
    transform: "translate(135.894 112.222)",
    fill: "#0094cd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(53.788 50.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M35.114,11.169H28.351l-.082.4-.575,2.711-.073.342-.329,1.533-.05.237-.023.1-.178.831-.128.607h4.413A3.253,3.253,0,0,0,34.2,15.52V15.5h0l.351-1.666.05-.233.388-1.83.128-.607h-.009Z",
    transform: "translate(42.123 -11.169)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M25.429,43.982H27.3a5.605,5.605,0,0,0,5.207-4.3L38.144,13.14H31.987L25.434,43.982Z",
    transform: "translate(36.834 -4.145)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M29.763,20.86l.009-.018a2.075,2.075,0,0,1,1.771-1.488h12.3l1.323-6.22H32.752c-2.766,0-4.847.561-6.188,1.666s-2.323,3.085-2.916,5.887c-.037.164-3.5,16.539-3.6,17.146a11.421,11.421,0,0,0-.16,1.2,6.1,6.1,0,0,0,.087,1.574,3.562,3.562,0,0,0,1.561,2.382,8.3,8.3,0,0,0,4.577,1.041h7.777a7.915,7.915,0,0,0,6.9-3.605,12.721,12.721,0,0,0,1.451-4.167l2.035-9.575H37.224l-.589,2.848H37.5l-1.428,6.7c-.361,1.054-1.273,1.588-2.725,1.588H27.923l-.032-.009A1.61,1.61,0,0,1,26.526,36.4v-.037l-.018-.119v-.073l3.259-15.3Z",
    transform: "translate(17.011 -4.166)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M43.928,13.056a9.422,9.422,0,0,0-1.825.173,6.281,6.281,0,0,0-4.545,3.8L29.315,33.994a.291.291,0,0,1-.319.155.288.288,0,0,1-.224-.278l-.087-16.963A3.376,3.376,0,0,0,25.8,13.225a8.4,8.4,0,0,0-1.7-.173,6.751,6.751,0,0,0-4.441,1.574,7.166,7.166,0,0,0-2.432,4.135L11.787,44.35h5.892l4.737-22.294a.287.287,0,0,1,.278-.228h.023a.289.289,0,0,1,.26.274l.776,18.967a7.322,7.322,0,0,0,.21,1.538,2.9,2.9,0,0,0,3.094,2.455A4.676,4.676,0,0,0,31.1,42.848l.05-.073.037-.05A11.131,11.131,0,0,0,32.2,40.963l.794-1.684,8.142-17.287a.289.289,0,0,1,.351-.151.282.282,0,0,1,.187.329L36.96,44.345h5.846l5.463-25.712h0a4.772,4.772,0,0,0-.653-4.062,4.4,4.4,0,0,0-3.692-1.529Z",
    transform: "translate(-11.786 -4.494)",
    fill: "#004b93"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoconnectmgi2White);
export default __webpack_public_path__ + "static/media/logoconnectmgi2white.dc7eee79300e7888299a93dfc392c0b4.svg";
export { ForwardRef as ReactComponent };